import React from "react";
// import { Provider } from "react-redux";
// import { BrowserRouter } from "react-router-dom";
// import UserSignUp from './components/SignUp/userSignUp'

import { createMuiTheme } from "@material-ui/core/styles";
// import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/styles.css";
import StartQuote from "./components/Shipping/startQuote";

import { pink } from "@material-ui/core/colors";
// import axios from 'axios'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#ffa726",
    },
    secondary: pink,
  },
});

function App() {
  return (
    <div>
      <MuiThemeProvider theme={theme}>
        <StartQuote />
      </MuiThemeProvider>
    </div>
  );
}

export default App;
